import { render } from "./OauthScienceId.vue?vue&type=template&id=391c3afc&scoped=true"
import script from "./OauthScienceId.vue?vue&type=script&lang=js"
export * from "./OauthScienceId.vue?vue&type=script&lang=js"

import "./OauthScienceId.vue?vue&type=style&index=0&id=391c3afc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391c3afc"]])

export default __exports__